'use client';

import cn from 'classnames';

import { FormEvent, HTMLProps, ReactElement, useMemo, useState } from 'react';
import { Spacing } from '../../types';
import { Icon } from '../Icon';

import s from './Checkbox.module.css';

export type CheckboxProps = {
  spacing?: Spacing;
} & HTMLProps<HTMLInputElement>;

const Checkbox = ({ checked, spacing, onChange, ...props }: CheckboxProps): ReactElement => {
  const [isChecked, setIsChecked] = useState<boolean>(checked as boolean);

  const checkedValue = useMemo(() => {
    if (typeof checked === 'boolean') return checked;
    return isChecked;
  }, [checked, isChecked]);

  const handleChange = (eve: FormEvent<HTMLInputElement>) => {
    const input = eve.target as HTMLInputElement;
    setIsChecked(input.checked);

    if (onChange) onChange(eve);
  };

  return (
    <div
      className={cn(s.checkbox, {
        [s.checked]: checkedValue,
        [`spacing-${spacing}`]: !!spacing,
      })}
    >
      {checkedValue && <Icon variant="solid" name="Check" color="white" size={20} />}
      <input type="checkbox" className={s.input} onChange={handleChange} {...props} />
    </div>
  );
};

export default Checkbox;
